'use strict';

var OfflineCalendarGridDirective = function OfflineCalendarGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/offline-calendar-review.html'),
    controller: 'OfflineCalendarReviewGridController',
    scope: {
      calendarKey: '@',
      displayedCalendar: '=',
      gridId: '='
    },
    link: function link($scope) {
      $scope.loadGrid();
      $scope.$watch('calendarKey', $scope.reloadIfNewCalendar);
    }
  };
};
OfflineCalendarGridDirective.$inject = [];
module.exports = OfflineCalendarGridDirective;